<template>
  <div class="wrapper login container-xl">
    <div class="login_content">
      <spacer :y="3"/>
      <div v-if="!flag.sended">
        <div :class="$style.title" v-if="isCreateWithPassword" class="my-4">本登録を完了するには登録したパスワードを入力してください。</div>
        <h2 :class="$style.title" v-else>パスワード登録</h2>
      </div>
      <spacer :y="3"/>
      <div :class="$style.wrapper" v-if="invalid">
        <p>
          アクティベートキーが無効です。<br />
          メールアドレス登録時のメールに記載されたURLから再度アクセスするか、ログインをお試しください。
        </p>
      </div>
      <form
        v-on:submit="submit"
        class="form_login form"
        :class="isVibration ? $style.vibration : ''"
        autocomplete="off"
        v-if="!invalid">
        <div :class="$style.form"
          v-if="!flag.sended">
          <div :class="$style.input">
            <input
              id="password"
              type="password"
              name="password"
              placeholder="パスワードを入力"
              v-model.trim="$v.password.$model"
              v-bind:class="{ input_error: validationFlags.password }"
              v-on:input="invalidsCheck('password', $v.password.$invalid)">
          </div>
          <p
            :class="$style.message"
            v-if="$v.password.$dirty && $v.password.required.$invalid">
            パスワードを入力してください</p>
          <p
            :class="$style.message"
            v-if="$v.password.$dirty && $v.password.minLength.$invalid">
            パスワードは8文字以上で設定してください</p>
          <spacer :y="3"/>
          <div
            class="mt-3"
            :class="$style.wrap"
            v-if="!flag.sended">
            <BasicBtn
              @click="submit"
              width="min-fix"
              v-bind:disabled="!submitFlag">
            登録</BasicBtn>
          </div>

        </div>
        <div
          :class="$style.message"
          v-if="flag.sended && flag.registed">
          <p>
            パスワードを登録しました。<br>
            <router-link :to="'/login/?isRegist=true'">ログインページ</router-link>よりログインしてください。
          </p>
        </div>
        <div
          :class="$style.message"
          v-if="flag.sended && flag.alreadyAuth">
          <p>
            既に本登録が完了しています。<br>
            <router-link :to="'/login/?isRegist=true'">ログインページ</router-link>よりログインしてください。
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import { Spacer, BasicBtn } from '@/components/parts';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'signupPassword',
  mixins: [cf],
  components: {
    Spacer,
    BasicBtn,
  },
  data() {
    return {
      isVibration: false,
      validationFlags: {
        password: false,
      },
      // 無効フラグ
      invalids: {
        password: true,
        minLength: true,
      },
      // パラメータなし等で無効
      invalid: true,
      activatekey: null,
      flag: {
        sended: false,
        registed: false,
        alreadyAuth: false,
      },
    };
  },
  created() {
    // パラメータが含まれているか確認
    const query = this.$route.query;
    if (query.activate) {
      this.invalid = false;
      this.activatekey = query.activate;
      this.isCreateWithPassword = query.isCreateWithPassword || 0;
    }
  },
  // https://qiita.com/tsuji_masayuki/items/2250f87b391a0bd374cc
  setup() {
    const password = ref('');

    const rules = {
      // パスワードは必須で8文字以上
      password: {
        required,
        minLength: minLength(8),
      },
    };

    const $v = useVuelidate(rules, { password });
    return { password, $v };
  },
  computed: {
    ...mapState(['user', 'page']),
    submitFlag() {
      // 無効フラグが全てfalseならばtrueを返却
      return !this.invalids.password;
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },

    /** サブミット */
    submit(e) {
      e.preventDefault();
      this.showLoading();

      if (this.isCreateWithPassword) {
        this.definitiveAuth();
      } else {
        this.createPassword();
      }
    },
    definitiveAuth() {
      // validateチェックは入力時に行われてる
      const data = {
        password: this.password,
        activatekey: this.activatekey,
      };

      this.axios({
        method: 'POST',
        url: '/v1/user/definitiveAuth',
        data,
      })
        .then((response) => {
          const resData = response.data;
          if (resData.status === 200) {
            if (resData.userId) {
              this.flag.registed = true;
              this.flag.sended = true;
            } else if (resData.alreadyAuth) {
              this.flag.sended = true;
              this.flag.alreadyAuth = true;
            }
          }
        })
        .catch((error) => {
          if (error.response.data.message === 'E_INVALID_AUTH_PASSWORD: Password mis-match') {
            this.isVibration = true;
            setTimeout(() => {
              this.isVibration = false;
            }, 750);
          }
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    createPassword() {
      // validateチェックは入力時に行われてる
      const data = {
        flag: 1,
        password: this.password,
        activatekey: this.activatekey,
      };

      this.axios({
        method: 'POST',
        url: '/v1/user/create/password',
        data,
      })
        .then((response) => {
          const resData = response.data;
          if (resData.registed) this.flag.registed = true;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.invalid = true;
        })
        .finally(() => {
          this.flag.sended = true;
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  display: flex;
  justify-content: center;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 0 auto;
}

.title {
  text-align: center;
  color: var(--orange-main);
}

.form {
  text-align: center;
}

.btn {
  display: inline-block;
  border-radius: 22px;
  border: none;
  background-color: #666;
  font-weight: bold;
  color: #fff;
  appearance: none;
  padding: 8px 25px;
  font-size: 16px;
}

.message {
  font-size: 14px;
  text-align: center;
}

.input {
  margin: 0 auto;
  width: 400px;
  max-width: 100%;
  position: relative;
  input {
    width: 100%;
    padding: 13px;
    border: none;
    background-color: var(--gray-sub);
    outline: none;
    border: 2px solid rgba(152, 121, 89, 1);
    border-radius: 15px;
    background-color: #ffffff;
  }
}
.vibration {
  animation: vibration .1s  infinite;
}
@keyframes vibration {
  0% {transform: translate(0px, 0px) rotateZ(0deg)}
  25% {transform: translate(2px, 2px) rotateZ(1deg)}
  50% {transform: translate(0px, 2px) rotateZ(0deg)}
  75% {transform: translate(2px, 0px) rotateZ(-1deg)}
  100% {transform: translate(0px, 0px) rotateZ(0deg)}
}
</style>
